import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/icon.css';
import 'babel-polyfill';
import axios from 'axios';
import QS from 'qs'
Vue.prototype.$bus = new Vue(); //中央事件总线;
Vue.prototype.$axios = axios;
Vue.prototype.$qs = QS;
import {postForm,get,postJson,postLogin,post,postFormData,postHeadJson,postDownload,getDownload} from './utils/request.js';

Vue.prototype.$postForm = postForm;
Vue.prototype.$postJson = postJson;
Vue.prototype.$postHeadJson = postHeadJson;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$postLogin = postLogin;
Vue.prototype.$postFormData = postFormData;
Vue.prototype.$postDownload = postDownload;
Vue.prototype.$getDownload = getDownload;

Vue.config.productionTip = false;
Vue.use(ElementUI, {
    size: 'small'
});

if (process.env.NODE_ENV === 'production') {
    if (window) {
      window.console.log = function () {};
    }
}

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title}`;
    const user = sessionStorage.getItem('user');
    if(to.query!=null && to.query.user != null && to.query.password != null && to.query.pt == 'pt'){
        sessionStorage.setItem('username',to.query.user);
        sessionStorage.setItem('au',to.query.au);
        sessionStorage.setItem('ap',to.query.ap);
        sessionStorage.setItem('outjump',"true");
        next();
        return;
    }
    if (!user && to.path !== '/login') {
        next('/login');
    } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
